module.exports = __webpack_public_path__ + "media/marukoma_video.2bd539b7.mp4";